export default __webpack_public_path__ + "static/media/avatar-3.4df0a434.jpg";